import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./Fees.module.css";
import FeeGroup from "./FeeGroup";
import FeesFooter from "./FeesFooter/FeesFooter";
import getFullAmount from "./getFullAmount";
import SampleWatermark from "../SampleWatermark";
import TabList from "containers/home/WorkList/TabList/Tablist";

const fullAmountIsNotZero = fee => {
  const accumulatedAmount = fee.description
    .map(getFullAmount)
    .reduce((acc, n) => acc + n, 0);
  return accumulatedAmount !== 0;
};

const tabs = {
  INSURER: "Insurer Retained",
  OWNER: "Owner Retained"
};

const sortBySequence = (a, b) =>
  +a.sequence > +b.sequence ? 1 : +a.sequence === +b.sequence ? 0 : -1;

const getFeeData = (isDual, activeTab, fees) => {
  const feeObject = isDual
    ? activeTab === tabs.INSURER
      ? fees[0]
      : fees[1]
    : fees;

  const paymentObject = feeObject.totalAmount.find(
    x => x.key === "TotalPayment"
  );
  const refundObject = feeObject.totalAmount.find(
    x => x.key === "TotalEstimate"
  );

  return {
    fees: feeObject.fees.sort(sortBySequence),
    payment: paymentObject ? paymentObject.value : "0.00",
    refund: refundObject ? refundObject.value : "0.00"
  };
};

const FeeSummary = ({ fees: feeData, isDual, state, className }) => {
  const [activeTab, setActiveTab] = useState(tabs.INSURER);
  const { fees, payment, refund } = getFeeData(isDual, activeTab, feeData);

  return (
    <section className={`${styles.base} ${className}`} data-fees-summary>
      <header className={styles.header}>
        <h3 className={styles.widgetTitle} id={`FeesSummary${state}`}>Fees Summary - {state}</h3>
      </header>
      {isDual ? (
        <TabList
          className={styles.tabs}
          activeItem={activeTab}
          onChange={setActiveTab}
          items={[tabs.INSURER, tabs.OWNER]}
        />
      ) : null}
      <div className={styles.widgetContent} style={{ padding: "0 24px" }}>
        {fees.length ? (
          <React.Fragment>
            <header className={styles.listHeader}>
              <span className={styles.feesIncludedSubTitle}>Fees Included</span>
              <span className={styles.amount}>Paid</span>
              <span className={styles.amount}>Refund</span>
            </header>
            <div className={styles.content}>
              <ul className={styles.list} data-fees-fields>
                {fees.filter(fullAmountIsNotZero).map(f => (
                  <FeeGroup
                    key={f.feeType}
                    title={f.feeType}
                    feesAmount={f.description}
                  />
                ))}
              </ul>
            </div>
          </React.Fragment>
        ) : (
          <div className={`${styles.content} ${styles.emptyFeesMessage}`} id="noRefund">
            <p id="fee_calculated">Total fees calculated for this claim is $0.</p>
            No refund is due to the owner
          </div>
        )}
        <FeesFooter totalPaid={payment} totalRefunded={refund} state={state} />
      </div>

      <SampleWatermark />
    </section>
  );
};

FeeSummary.propTypes = {
  fees: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  state: PropTypes.string.isRequired,
  className: PropTypes.string
};

FeeSummary.defaultProps = {
  className: ""
};

export default FeeSummary;
